export const servicesData = [
  {
    id: 1,
    icon: "Brain",
    title: "Anxiety & Stress Management",
    description: "Calm the mental noise and reclaim your peace through evidence-based techniques and personalized strategies."
  },
  {
    id: 2,
    icon: "Heart",
    title: "Relationship Counselling",
    description: "Heal connections and build healthier bonds with partners, family members, and friends."
  },
  {
    id: 3,
    icon: "CloudRain",
    title: "Depression Therapy",
    description: "Rediscover hope, joy, and purpose in daily life with compassionate, effective treatment."
  },
  {
    id: 4,
    icon: "Leaf",
    title: "Trauma & PTSD Recovery",
    description: "Process the past and heal safely at your pace with specialized trauma-informed care."
  },
  {
    id: 5,
    icon: "Users",
    title: "Family & Parenting Support",
    description: "Strengthen family dynamics and improve communication for healthier relationships."
  },
  {
    id: 6,
    icon: "GraduationCap",
    title: "Career & Life Transitions",
    description: "Navigate change with clarity and confidence through guided exploration and support."
  }
];

export const testimonialsData = [
  {
    id: 1,
    quote: "Priya helped me find light in my darkest times. Her patience and approach changed my life.",
    name: "Anjali S.",
    location: "Jaipur",
    initials: "AS"
  },
  {
    id: 2,
    quote: "I was skeptical about therapy, but Dr. Priya made me feel heard from the very first session.",
    name: "Rohan M.",
    location: "Delhi",
    initials: "RM"
  },
  {
    id: 3,
    quote: "Her CBT sessions helped me manage my anxiety at work. Truly life-changing.",
    name: "Meera K.",
    location: "Jaipur",
    initials: "MK"
  },
  {
    id: 4,
    quote: "Finally found someone who understands without judgment. Grateful for every session.",
    name: "Vikram T.",
    location: "Jaipur",
    initials: "VT"
  },
  {
    id: 5,
    quote: "Priya's guidance through my grief was gentle and deeply effective.",
    name: "Sunita R.",
    location: "Rajasthan",
    initials: "SR"
  },
  {
    id: 6,
    quote: "The tools she gave me for managing stress have become part of my daily life.",
    name: "Aditya P.",
    location: "Jaipur",
    initials: "AP"
  }
];

export const credentialsData = [
  "M.Phil Clinical Psychology",
  "CBT Certified",
  "Licensed by RCI",
  "5+ Years Experience"
];

export default { servicesData, testimonialsData, credentialsData };
